import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import {
    Alert,
    AlertTitle,
    Box,
    Button,
    Grid,
    Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AvailabilityList from '../components/Calendar/AvailabilityList';
import Calendar from '../components/Calendar/Calendar';
import Loading from '../components/Loading';
import Title from '../components/Navbar/Title';
import ProfileWarning from '../components/Profile/ProfileWarning';
import { fetchMyAvailability } from '../redux/AvailabilitySlice';

const LinkColor = styled(Link)(({ theme }) => ({
    color: theme.palette.primary.main,
    '&:hover': {
        color: theme.palette.secondary.main,
        'text-decoration': 'none',
    },
}));

const validPermission = 'create:availability';

const TeacherAvailability = props => {
    const [redirectToHome, setRedirectToHome] = useState(false);

    const [countDown, setCountDown] = useState(20);

    const { profile } = useSelector(state => state.profile);
    const { availability } = useSelector(state => state.availability);
    const { token } = useSelector(state => state.token);
    const availabilityStatus = useSelector(state => state.availability.status);
    const profileStatus = useSelector(state => state.profile.status);
    const availabilityError = useSelector(state => state.availability.error);
    const tokenStatus = useSelector(state => state.token.status);
    const dispatch = useDispatch();

    const { getAccessTokenSilently } = useAuth0();

    console.log('Availability Status is: ' + availabilityStatus);

    useEffect(() => {
        //useEffect is completed on page load
        //Service to get the profile for a user
        console.log(
            'status of profile ' + profileStatus + ' ' + profile.Data.Count
        );
        // if (profileStatus === 'idle') {
        //     async function dispatchProfileFromStore() {
        //         const token = await getAccessTokenSilently({
        //             scope: process.env.REACT_APP_scope,
        //         });
        //         // var decoded = JSON.stringify(await jwt_decode(token));
        //         // setState({
        //         //   ...state,
        //         //   decoded: decoded
        //         // });

        //         dispatch(storeToken(token));
        //         dispatch(fetchProfile(token));
        //     }
        //     dispatchProfileFromStore();
        // }
        if (profileStatus === 'succeeded' && profile.Data.Count === 0) {
            setRedirectToHome(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAccessTokenSilently, profileStatus, dispatch]);

    useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            if (token.permissions.includes(validPermission) === false)
                setRedirectToHome(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenStatus, token.Count, token.permissions]);

    useEffect(() => {
        //Service to get the availability for specific geohash and date
        if (availabilityStatus === 'idle') {
            async function dispatchAvailabilityFromStore() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                dispatch(fetchMyAvailability(token));
            }
            dispatchAvailabilityFromStore();
        }
    }, [getAccessTokenSilently, availabilityStatus, dispatch]);

    useEffect(() => {
        console.log('run x times');
        if (redirectToHome) {
            setTimeout(() => {
                var interimNumber = countDown - 1;
                setCountDown(interimNumber);
            }, 1000);
        }
    }, [redirectToHome, countDown]);

    let rows = availability.Data;
    if (availability.Data.length) {
        rows = [...availability.Data];
        rows.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    }

    let content;

    if (availabilityStatus === 'loading') {
        content = <Loading />;
    } else if (redirectToHome) {
        content = (
            <ProfileWarning
                message="You cannot enter date into your calendar until your profile
        is verified"
                redirectTime={countDown}
            />
        );
    } else if (
        profileStatus === 'succeeded' &&
        availabilityStatus === 'succeeded'
    ) {
        // if (state.grade === '') {
        //     incompleteInfoMessage = {
        //         message: 'Teacher information is incomplete',
        //         severity: 'warning',
        //     };
        // }
        content = (
            <div>
                <Title title="My Availability" />
                <Grid
                    xs={12}
                    container
                    directon="row"
                    justifyContent="center"
                    alignItems="stretch"
                >
                    {redirectToHome && (
                        <Grid item xs={12}>
                            <Alert
                                severity="warning"
                                sx={{ padding: '20px 40px' }}
                            >
                                <Box sx={{ m: 1 }}>
                                    <AlertTitle>Warning</AlertTitle>
                                    You cannot enter date into your calendar
                                    until your profile is verified —{' '}
                                    <strong>
                                        Finish setting up your Profile
                                    </strong>
                                    Redirect will happen in {countDown}
                                </Box>
                                <LinkColor to="/profile/skills">
                                    <Button
                                        color="secondary"
                                        variant="outlined"
                                    >
                                        Profile Page
                                    </Button>
                                </LinkColor>
                            </Alert>
                        </Grid>
                    )}
                    <Grid item sm={12} xs={12} lg={8} md={10} sx={{ p: 0 }}>
                        <Calendar disabled={redirectToHome} />
                    </Grid>

                    <Grid
                        item
                        lg={4}
                        md={10}
                        sm={12}
                        xs={12}
                        sx={{ width: '100%', maxWidth: 500, padding: '10px' }}
                    >
                        <Box sx={{ padding: '30px 10px 10px' }}>
                            <Typography
                                variant="h5"
                                align="center"
                                sx={{ marginTop: '10px' }}
                            >
                                Available Dates (List format)
                            </Typography>
                            <Typography variant="body1" align="center">
                                Below are the list of dates you are available
                                for
                            </Typography>
                        </Box>

                        <AvailabilityList list={rows} />
                    </Grid>
                </Grid>
            </div>
        );
    } else if (
        availabilityStatus === 'error' ||
        availabilityStatus === 'failed'
    ) {
        content = <div>{availabilityError}</div>;
    }

    return <div>{content}</div>;
};

export default connect(null)(
    withAuthenticationRequired(TeacherAvailability, {
        onRedirecting: () => <Loading />,
    })
);
